import React from 'react';
import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';

interface NavigationItem {
  name: string;
  href: string;
  icon: LucideIcon;
  onAction?: () => void; // If set, calls this instead of navigating
}

interface MobileBottomNavProps {
  navigation: NavigationItem[];
  isActive: (href: string) => boolean;
}

const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ navigation, isActive }) => {

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-secondary-200 shadow-lg lg:hidden">
      <div 
        className="flex items-center justify-around px-2 py-2"
        style={{ paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom))' }}
      >
        {navigation.map((item) => {
          const Icon = item.icon;
          const active = !item.onAction && isActive(item.href);

          // If the item has an onAction callback, render a button instead of a Link
          if (item.onAction) {
            return (
              <button
                key={item.name}
                onClick={item.onAction}
                className="flex flex-col items-center justify-center min-h-[44px] px-3 py-2 rounded-lg transition-colors text-secondary-600"
              >
                <Icon className="h-5 w-5 mb-1 text-secondary-600" />
                <span className="text-xs font-medium">{item.name}</span>
              </button>
            );
          }
          
          return (
            <Link
              key={item.href}
              to={item.href}
              className={`flex flex-col items-center justify-center min-h-[44px] px-3 py-2 rounded-lg transition-colors ${
                active
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-secondary-600'
              }`}
            >
              <Icon className={`h-5 w-5 mb-1 ${active ? 'text-primary-700' : 'text-secondary-600'}`} />
              <span className="text-xs font-medium">{item.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;

